import React from 'react'

type Props = {
    className?  : string

    icon?       : string | null
    value?      : string | number

    background? : boolean
    pastdue?    : boolean

    children?   : any
}

export default function PropertyGray(props:Props) {
    // props.background
    // props.pastdue

    // if props.background = false it WON'T add gray (!)

    const classes = Classes('ui5-prop', props.className, {
        'gray': props.background!==false && !props.pastdue,
        'gray-pastdue': props.background!==false && props.pastdue,
    })

    //Classes('ui5-prop', props.className, {'gray': props.background!==false} )

    return (
        <div className={classes}>
            {props.icon &&
            <div className={Classes('ico', props.icon)} />}

            {props.value}
            {props.children}
        </div>
    )
}